import type { PageData, ProfileGroup } from 'types/Page';

export function deriveActiveReportProfiles(
  selectedPage: PageData | null,
  selectedProfileGroup: ProfileGroup | null,
  isGroupSelected: boolean,
): number[] {
  if (isGroupSelected && selectedProfileGroup) {
    return Array.from(
      new Set(selectedProfileGroup.pages.map((page) => page.type)),
    );
  }

  if (selectedPage) {
    return [selectedPage.type];
  }

  return [];
}
